// extracted by mini-css-extract-plugin
module.exports = {"images":"card_images__7KutD","name":"card_name__2dhlq","container":"card_container__3WaTE","button":"card_button__2AHbR","infor":"card_infor__13NxB"};